import {combineReducers} from '@reduxjs/toolkit';
import lightProjects from './lightProjects/lightProjectsSlice';

const searchEntities = combineReducers({
  lightProjects,
});

export default searchEntities;
